import { Link } from "react-router-dom";
import { Bell, ChevronRight } from "lucide-react";
import { Avatar } from "./Avatar";
import { useNotifications } from "../context/NotificationsContext";
import { useT } from "../i18n";

export const NotificationsBanner = () => {
  const { t } = useT();
  const { unread, items, markRead } = useNotifications();
  const fresh = items.filter((n) => !n.read);
  if (!unread || fresh.length === 0) return null;
  const race = fresh[0].race_name;
  return (
    <section className="panel mt-5 border-rox-orange/50 p-4 animate-rise-in" data-testid="notifications-banner">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2">
          <Bell size={16} className="text-rox-orange" />
          <p className="font-display text-base uppercase tracking-wide" data-testid="notifications-banner-title">{t("notif_banner", fresh.length, race)}</p>
        </div>
        <button data-testid="notifications-seen" onClick={markRead} className="shrink-0 text-[11px] font-semibold uppercase tracking-wider text-rox-muted hover:text-rox-orange">{t("notif_seen")}</button>
      </div>
      <div className="mt-3 grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
        {fresh.map((n) => (
          <Link key={n.id} to={`/athlete/${n.profile.id}`} onClick={markRead} data-testid={`notification-${n.profile.id}`} className="flex items-center gap-3 rounded-[4px] bg-rox-black px-3 py-2 transition-colors hover:text-rox-orange">
            <Avatar name={n.profile.first_name} src={n.profile.photo_url} size={36} ring={false} />
            <div className="min-w-0 flex-1">
              <p className="h-display text-lg">{n.profile.first_name}{n.profile.age ? `, ${n.profile.age}` : ""}</p>
              <p className="truncate text-[11px] text-rox-muted">{n.profile.city} · {t("notif_compat", n.score)}</p>
            </div>
            <ChevronRight size={16} className="shrink-0 text-rox-muted" />
          </Link>
        ))}
      </div>
    </section>
  );
};
